import { render, staticRenderFns } from "./SidebarMenuTree.vue?vue&type=template&id=b8667586&scoped=true"
import script from "./SidebarMenuTree.vue?vue&type=script&lang=js"
export * from "./SidebarMenuTree.vue?vue&type=script&lang=js"
import style0 from "./SidebarMenuTree.vue?vue&type=style&index=0&id=b8667586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8667586",
  null
  
)

export default component.exports